'use client';

import { useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import { datePickerSlotProps, SearchBox, StyledContainer } from '~/shared';
import type { MonitoringFilters as Filters } from '~/types/monitoring';

interface MonitoringFiltersProps {
  onFilter: (filters: Filters) => void;
}

export const MonitoringFilters = ({ onFilter }: MonitoringFiltersProps) => {
  const [campaignQuery, setCampaignQuery] = useState('');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [status, setStatus] = useState('');

  const handleCampaignQueryChange = (value: string) => {
    setCampaignQuery(value);
    onFilter({
      campaignId: value,
      startDate: startDate?.toISOString() || '',
      endDate: endDate?.toISOString() || '',
      status,
    });
  };

  const handleStartDateChange = (value: Date | null) => {
    setStartDate(value);
    onFilter({
      campaignId: campaignQuery,
      startDate: value?.toISOString() || '',
      endDate: endDate?.toISOString() || '',
      status,
    });
  };

  const handleEndDateChange = (value: Date | null) => {
    setEndDate(value);
    onFilter({
      campaignId: campaignQuery,
      startDate: startDate?.toISOString() || '',
      endDate: value?.toISOString() || '',
      status,
    });
  };

  const handleStatusChange = (value: string) => {
    setStatus(value);
    onFilter({
      campaignId: campaignQuery,
      startDate: startDate?.toISOString() || '',
      endDate: endDate?.toISOString() || '',
      status: value,
    });
  };

  return (
    <StyledContainer>
      <Box
        sx={theme => ({
          display: 'flex',
          gap: 2,
          mb: 0,
          [theme.breakpoints.down('lg')]: { flexDirection: 'column' },
        })}
      >
        <SearchBox
          label="Procurar por ID, Anunciante ou Campanha"
          onChange={handleCampaignQueryChange}
          value={campaignQuery}
          fullWidth
        />
        <Box
          sx={theme => ({
            display: 'flex',
            gap: 2,
            width: '100%',
            [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
          })}
        >
          <FormControl variant="filled" fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              label="Status"
              onChange={e => handleStatusChange(e.target.value)}
              sx={{ borderRadius: 0 }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="NORMAL">Normal</MenuItem>
              <MenuItem value="ATENCAO">Atenção</MenuItem>
              <MenuItem value="CRITICO">Crítico</MenuItem>
            </Select>
          </FormControl>

          <DatePicker
            sx={{ width: '100%' }}
            label="Início"
            value={startDate}
            onChange={handleStartDateChange}
            slotProps={datePickerSlotProps('')}
          />

          <DatePicker
            sx={{ width: '100%' }}
            label="Término"
            value={endDate}
            onChange={handleEndDateChange}
            slotProps={datePickerSlotProps('')}
          />
        </Box>
      </Box>
    </StyledContainer>
  );
};
